import React, { Component } from 'react';
import { isEqual } from '../../../utils/lodash';
import clsx from 'clsx';

import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

import {
  getTransformedTrplsArrayToObj,
  trplsParamsTable,
  isJsonObject,
} from '../../../utils';

import Node from '../../Node';

import { HighlightedTableCell } from './TableHighlighting';
import TrplWrapper from './TrplWrapper';
import CellCustomComponent from './CellCustomComponent';

export default class TrplsTableRowCell extends Component {
  state = {
    cellContentHeight: 29,
    gotHeight: false,
  };

  componentDidMount() {
    const cellKey = `${this.props.rstIndex}.${this.props.nodeId}`;
    const cellkey = document.getElementById(cellKey);
    const cellHeight = cellkey && cellkey.offsetHeight ? cellkey.offsetHeight : 29;
    this.setState({ gotHeight: true, cellContentHeight: cellHeight });
  };

  shouldComponentUpdate(nextProps) {
    const { rst, rstChainId } = this.props;

    return (
      ((this.props.rowMaxHeight !== nextProps.rowMaxHeight) && (this.state.cellContentHeight < this.props.rowMaxHeight)) ||
      this.props.hideColumns.includes(rstChainId) !== nextProps.hideColumns.includes(rstChainId) ||
      !isEqual(this.props.collectedTrpls, nextProps.collectedTrpls) ||
      (Array.isArray(rst) || isJsonObject(rst))
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.collectedTrpls !== prevProps.collectedTrpls) {
      const cellKey = `${this.props.rstIndex}.${this.props.nodeId}`;
      const cellkey = document.getElementById(cellKey);
      const cellHeight = cellkey && cellkey.offsetHeight ? cellkey.offsetHeight : 29;
      if (cellHeight && (prevState.cellContentHeight !== cellHeight)) {
        this.setState({ gotHeight: false }, () => this.setState({ gotHeight: true, cellContentHeight: cellHeight}));
      }
    }
  };

  render() {
    const { gotHeight, cellContentHeight } = this.state;
    const {
      rst,
      mode,
      node,
      trpls,
      nodeId,
      tableId,
      isEmbed,
      classes,
      rowIndex,
      rstIndex,
      whiteRows,
      rstChainId,
      expandCell,
      isSelected,
      ancestorId,
      individuals,
      hideColumns,
      rowMaxHeight,
      rowBorderBold,
      collectedTrpls,
      openTrplFormFull,
      onRstTypeBtnClick,
      trplSaveDataImport,
      openTrplFormWithRst,
      onNodeRemoveBtnClick,
      isRestrictionOverrided,
      maxCellAncestorsByChain,
      collectTrplsByChainAndNode,
    } = this.props;

    const allCellAncestors = rst && rst.custom_pid && maxCellAncestorsByChain && rst.custom_pid.length > 1
      && maxCellAncestorsByChain[rst.custom_pid[0]] ? maxCellAncestorsByChain[rst.custom_pid[0]] : null;

    let nodesByCustomPid;
    let allAncestorsNodes;
    let missingAncestorsIndexes;

    if (rst && rst.custom_pid) {
      const trplsByCastomPid = collectTrplsByChainAndNode(rst.custom_pid, trpls, individuals);

      if (trplsByCastomPid) {
        nodesByCustomPid = trplsByCastomPid.map(trpl => trpl && trpl.oid);
        allAncestorsNodes = trplsByCastomPid.map(trpl => trpl && trpl.sid);
      }
      if (allCellAncestors) {
        missingAncestorsIndexes = Object.keys(allCellAncestors).reduce((arr, id, index) => {
          const idToNumber = +id;
          const arrWithIndex = !allAncestorsNodes.includes(idToNumber) ? [...arr, index] : arr;
          return arrWithIndex;
        }, []);
      }
    }

    const cellIsHidden = hideColumns.includes(rstChainId);

    const cellClassName = `${classes.tableCell} ${classes.tableCellHover} ${rowBorderBold ? classes.tableCellBold : classes.tableCellRegular} ${
      cellIsHidden ? classes.hiden : ''} ${
      isSelected ? classes.tableCellSelected :
        (isEmbed ? (rowIndex % 2 === 0 && !whiteRows ? classes.halfTransparentWhite : classes.semiTansparentWhite) : classes.semiTansparentWhite)}`;

    const cellKey = `${rstChainId}.${rstIndex}.${nodeId}`;

    const individualsNodes = individuals && individuals.nodes;

    return (
      <HighlightedTableCell
        key={cellKey}
        nodeId={nodeId}
        tableId={tableId}
        ancestorId={ancestorId}
        rstChainId={rstChainId}
        cellClassName={cellClassName}
        classes={classes}
      >
        {mode === 'NONE' ? '\u200B' :
          (isJsonObject(rst) && rst.custom_pid && rst.custom_pid.length) ?
          <div key={rstIndex} style={{ overflow: 'hidden' }}>
            {nodesByCustomPid && nodesByCustomPid.map((customNodeId, nodeIndex) => {
              const trpls = getTransformedTrplsArrayToObj(individuals.trpls, customNodeId, trplsParamsTable);
              const trplsAncestorNode = allAncestorsNodes[nodeIndex];

              const dividerColor = (allAncestorsNodes[nodeIndex] !== allAncestorsNodes[nodeIndex + 1]) ||
                (rst.custom_pid && rst.custom_pid.length === 1) ? '#C9C4E4' :'#E6E5F1';

              let emptyCellsBeforeArr;
              if (missingAncestorsIndexes && missingAncestorsIndexes.length) {
                const currentAncestorIndex = Object.keys(allCellAncestors).indexOf(`${trplsAncestorNode}`);
                emptyCellsBeforeArr = missingAncestorsIndexes.filter(el => el < currentAncestorIndex);
              }
              
              return (
                <React.Fragment key={nodeIndex}>
                  {emptyCellsBeforeArr && emptyCellsBeforeArr.length && allAncestorsNodes[nodeIndex] !== allAncestorsNodes[nodeIndex - 1]
                  ? emptyCellsBeforeArr.map((cellIndex, index) => {
                    return (
                      <div
                        key={`${cellIndex}.${nodeIndex}`}
                        style={{
                          height: `${Object.values(allCellAncestors)[cellIndex]}px`,
                          boxSizing: 'border-box',
                          borderBottom: `1px dashed #C9C4E4`,
                        }}
                      ></div>
                    )
                  }) : null}

                  <div
                    className={`cell-${trplsAncestorNode}.${customNodeId}`}
                    id={`${trplsAncestorNode}.${customNodeId}`}
                    key={`${customNodeId}.${nodeIndex}`}
                    style={{
                      boxSizing: 'border-box',
                      borderBottom: nodesByCustomPid.length > 1 ? `1px dashed ${dividerColor}` : '',
                      // borderBottom: (customNodeId !== customNodeId[nodeIndex + 1]) &&
                      //   (rst.custom_pid.length === 1 ? (nodesByCustomPid.length - 1 !== nodeIndex) : true) ?
                      //   `1px dashed ${dividerColor}` : '',
                    }}
                  >
                    <CellCustomComponent
                      node={node}
                      mode={mode}
                      key={nodeIndex}
                      trpls={trpls}
                      nodeId={nodeId}
                      classes={classes}
                      rstIndex={rstIndex}
                      nodeIndex={nodeIndex}
                      individuals={individuals}
                      openTrplFormFull={openTrplFormFull}
                      onRstTypeBtnClick={onRstTypeBtnClick}
                      trplsAncestorNode={trplsAncestorNode}
                      trplSaveDataImport={trplSaveDataImport}
                      custom_component={rst.custom_component}
                      openTrplFormWithRst={openTrplFormWithRst}
                      onNodeRemoveBtnClick={onNodeRemoveBtnClick}
                      collectTrplsByChainAndNode={collectTrplsByChainAndNode}
                    />
                  </div>
                  </React.Fragment>
                )
              })
            }
          </div>
        : (isJsonObject(rst) && rst.type && rst.type === 'custom') ?
          <div key={rstIndex} style={{ overflow: 'hidden' }}>
            <CellCustomComponent
              node={node}
              mode={mode}
              trpls={trpls}
              nodeId={nodeId}
              classes={classes}
              rstIndex={rstIndex}
              individuals={individuals}
              openTrplFormFull={openTrplFormFull}
              onRstTypeBtnClick={onRstTypeBtnClick}
              custom_component={rst.custom_component}
              trplSaveDataImport={trplSaveDataImport}
              openTrplFormWithRst={openTrplFormWithRst}
              onNodeRemoveBtnClick={onNodeRemoveBtnClick}
              collectTrplsByChainAndNode={collectTrplsByChainAndNode}
            />
          </div>
        : (Array.isArray(rst)) ?
          <div key={rstIndex} className={classes.flex} style={{ margin: '1px', overflow: 'hidden' }}>
            {rst.map((item, pidIndex) => {
              const collectedTrpls = collectTrplsByChainAndNode(item.pids, trpls, individuals);

              return (
                <div key={pidIndex}>
                  <TrplWrapper
                    rst={rst}
                    node={node}
                    mode={mode}
                    nodeId={nodeId}
                    classes={classes}
                    pidIndex={pidIndex}
                    rstIndex={rstIndex}
                    collectedTrpls={collectedTrpls}
                    openTrplFormFull={openTrplFormFull}
                    individualsNodes={individualsNodes}
                    onRstTypeBtnClick={onRstTypeBtnClick}
                    trplSaveDataImport={trplSaveDataImport}
                    openTrplFormWithRst={openTrplFormWithRst}
                    onNodeRemoveBtnClick={onNodeRemoveBtnClick}
                  />
                </div>
              )
            })}
          </div>
        : rst.id ?
          <div
            key={rst.id}
            id={cellKey}
            style={{ overflow: 'hidden', maxHeight: gotHeight ? rowMaxHeight : 'fit-content', minHeight: '21px' }}
          >
            <TrplWrapper
              rst={rst}
              node={node}
              mode={mode}
              nodeId={nodeId}
              classes={classes}
              rstIndex={rstIndex}
              individuals={individuals}
              collectedTrpls={collectedTrpls}
              openTrplFormFull={openTrplFormFull}
              individualsNodes={individualsNodes}
              onRstTypeBtnClick={onRstTypeBtnClick}
              trplSaveDataImport={trplSaveDataImport}
              openTrplFormWithRst={openTrplFormWithRst}
              onNodeRemoveBtnClick={onNodeRemoveBtnClick}
              isRestrictionOverrided={isRestrictionOverrided}
            />
          </div>
        : 
          <div
            key={rst.nodeId}
            className={classes.trplTableNodes}
          >
            <Node
              isLink
              size="xs"
              nodeId={nodeId}
              nodes={individualsNodes}
              customTitle={rst.nodeBtnTitle}
              formEdit={rst.obj_editable_frm}
              node={individualsNodes && individualsNodes[nodeId]}
              onClick={() => {
                openTrplFormFull({
                  node: individualsNodes[nodeId],
                  mode: 'edit',
                  initialNodeId: nodeId,
                  obj_editable_frm: rst.obj_editable_frm,
                });
              }}
            />
          </div>
        }
        {(rowMaxHeight + 22) < cellContentHeight ?
          <div
            className={clsx(
              classes.showMoreInCell,
              classes.justifyCenter,
              classes.fillAvailable,
              classes.absolute,
              classes.pointer,
            )}
            onClick={() => {
              expandCell(cellContentHeight);
            }}
          >
            <button
              className={classes.alignCenter}
              type="button"
              style={{ lineHeight: '1.1'}}
            >
              Show more
              <KeyboardArrowDownOutlinedIcon
                style={{
                  fontSize: '17px',
                  color: '#222029'
                }}
              />
            </button>
          </div>
        : null}
      </HighlightedTableCell>
    );
  }
};
